import { Subscription } from '@stencil/store'
import { readableColor } from 'polished'

import { hexColorForString } from './color'

declare global {
  interface Window {
    fathomLogger?: Console
  }
}

/**
 * Allows for frontend logging when `window.fathomLogger` has been defined
 * ```js
 * window.fathomLogger = console
 * ```
 */
export function log(...args: any[]) {
  window.fathomLogger && window.fathomLogger.log(...args)
}

/**
 * Log a @stencil/store's state transition
 * @param storeName The name used to refer to the store in logs
 * @param ignoreProps Any props specified here will not be logged
 */
export function useLogging<T>(storeName: string, ignoreProps: Array<keyof T> = []): Subscription<T> {
  return {
    set(key, value, oldValue) {
      if (!ignoreProps.includes(key)) {
        logWithBadge(storeName, key, oldValue, '->', value)
      }
    },
  }
}

export function logWithBadge(label: string, ...params) {
  const badgeColor = hexColorForString(label)
  const textColor = readableColor(badgeColor)
  log(
    `%c${label}`,
    `background: ${badgeColor}; color: ${textColor}; padding: .3em 1ch; border-radius: .3em`,
    window.location.href,
    ...params
  )
}
